import Vue from "vue";
import Vuex from "vuex";
import loader from "./modules/loader";
import apps from "./modules/apps";
import archives from "./modules/archives";
import user from "./modules/user";
import applications from "./modules/applications";
import permissions from "./modules/permissions";
import logs from "./modules/logs";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: { loader, apps, archives, user, applications, permissions, logs },
});
